<template>
	<v-app-bar
			id="core-app-bar"
			absolute
			app
			color="transparent"
			flat
			dense
	>
		<v-toolbar-title class="tertiary--text font-weight-light align-self-center">
			<v-btn
					v-if="responsive"
					icon
					@click.stop="onClick"
			>
				<v-icon>mdi-view-list</v-icon>
			</v-btn>
			{{ title }}
		</v-toolbar-title>

		<v-spacer />

		<v-toolbar-items>
			<v-row
					align="center"
					class="mx-0"
			>
				<v-chip
					v-if="$vuetify.breakpoint.smAndUp"
					color="grey darken-3"
					label
					outlined
				>
					<span class="font-weight-bold">{{ user.name }}</span>&nbsp;
					<span class="font-weight-light">({{ user.email }})</span>
				</v-chip>

				<v-tooltip left bottom>
					<template #activator="{ on }">
						<v-btn icon to="/" v-on="on">
							<v-icon color="tertiary">
								mdi-view-dashboard
							</v-icon>
						</v-btn>
					</template>
					<span>Главный экран</span>
				</v-tooltip>

				<v-tooltip left bottom>
					<template #activator="{ on }">
						<v-btn
							icon
							class="d-none d-md-flex"
							@click="toggleDarkMode"
							v-on="on"
						>
							<v-icon color="tertiary">
								mdi-theme-light-dark
							</v-icon>
						</v-btn>
					</template>
					<span v-if="$vuetify.theme.dark">Отключить темную тему</span>
					<span v-else>Включить темную тему</span>
				</v-tooltip>

				<app-notifications />

				<v-tooltip left bottom>
					<template #activator="{ on }">
						<v-btn
							icon
							@click="handleLogout"
							v-on="on"
						>
							<v-icon color="tertiary">
								mdi-logout
							</v-icon>
						</v-btn>
					</template>
					<span>Выйти</span>
				</v-tooltip>
			</v-row>
		</v-toolbar-items>
		<template v-for="(snackbar, key) in snackbars">
			<v-snackbar
					:key="key"
					v-model="snackbar.show"
			>
				{{ snackbar.text }}
				<v-btn
						color="pink"
						text
						@click="snackbar.show = false"
				>
					Закрыть
				</v-btn>
			</v-snackbar>
		</template>
	</v-app-bar>
</template>

<script>
	// Utilities
	import {
		mapMutations,
		createNamespacedHelpers,
	} from 'vuex'
	import AppNotifications from '@/components/core/app-notifications';

	const STORE_AUTH = createNamespacedHelpers('auth');

	export default {
		components: { AppNotifications },
		data() {
			return {
				title: null,
				responsive: false,
				snackbars: [],
			};
		},
		computed: {
			...STORE_AUTH.mapState([ 'user' ]),
		},
		watch: {
			'$route': {
				handler(val) {
					this.title = val.meta && val.meta.hasOwnProperty('title') ? val.meta.title : '';
				},
				immediate: true,
			},
		},
		mounted() {
			this.onResponsiveInverted();
			window.addEventListener('resize', this.onResponsiveInverted);
		},
		beforeDestroy() {
			window.removeEventListener('resize', this.onResponsiveInverted)
		},
		methods: {
			...mapMutations('app', [ 'setDrawer', 'toggleDrawer' ]),
			...STORE_AUTH.mapActions([ 'logout' ]),
			onClick() {
				this.setDrawer(!this.$store.state.app.drawer)
			},
			onResponsiveInverted() {
				if (window.innerWidth < 991) {
					this.responsive = true
				} else {
					this.responsive = false
				}
			},
			async handleLogout() {
				await this.logout();
				await this.$router.push('/login');
			},
			toggleDarkMode() {
				this.$vuetify.theme.dark = !this.$vuetify.theme.dark;
			},
		},
	}
</script>

<style>
	/* Fix coming in v2.0.8 */
	#core-app-bar {
		width: auto;
	}

	#core-app-bar a {
		text-decoration: none;
	}
</style>
